var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loading"},[(!_vm.show)?_c('span',[_vm._t("default")],2):_c('span',[_vm._v(" ")]),(_vm.show)?_c('div',{staticClass:"lds-css ng-scope"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-spinner"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }